import { createSlice } from '../../utils/createAppSlice'
import { initialState } from './importInitialState'
import { resetImportFlow, saveImportStep, setCampaignPayload } from './importReducers'
import { getCampaignPayload, getImportStep } from './importSelectors'

export const importSlice = createSlice({
	name: 'import',
	initialState,
	reducers: (create) => ({
		actionSaveImportStep: create.reducer(saveImportStep),
		actionResetImportFlow: create.reducer(resetImportFlow),
		actionSetCampaignPayload: create.reducer(setCampaignPayload),
	}),
	selectors: {
		selectImportStep: getImportStep,
		selectCampaignPayload: getCampaignPayload,
	},
})

export const { actionSaveImportStep, actionResetImportFlow, actionSetCampaignPayload } = importSlice.actions

export const { selectImportStep, selectCampaignPayload } = importSlice.selectors
